import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  successState: {
    message: "",
    success: false,
    openModal: false,
  },
};

const successSlice = createSlice({
  name: "success",
  initialState,
  reducers: {
    handleSuccessState: (state, action) => {
      state.successState = { ...state.successState, ...action.payload };
    },
  },
});

export const { handleSuccessState } = successSlice.actions;
export default successSlice.reducer;
